import { render, staticRenderFns } from "./Category.vue?vue&type=template&id=1d080b1a&scoped=true&"
import script from "./Category.vue?vue&type=script&lang=ts&"
export * from "./Category.vue?vue&type=script&lang=ts&"
import style0 from "./Category.vue?vue&type=style&index=0&id=1d080b1a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d080b1a",
  null
  
)

export default component.exports